<template>
  <div v-if="retributionsAnalytics" class="mt-6 space-y-6">
    <ManagementRetributionView v-if="showManagementRetributionView" :retributionsAnalytics="retributionsAnalytics" />

    <div v-if="!retributionsAnalytics.retributionConfigurationsExist" class="bg-purple-50 rounded-lg p-8 text-center">
      <div class="mx-auto w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4">
        <CheckCircleIcon class="w-8 h-8 text-purple-200" />
      </div>
      <h3 class="text-xl font-semibold text-gray-900 mb-2">Configurez le système de primes</h3>
      <p class="text-gray-600 mb-4">
        Afin de motiver vos équipes à proposer les services d'assurance ou de garantie, vous avez la possibilité de leur
        rétribuer une partie de votre rémunération.
      </p>
    </div>

    <div v-else class="space-y-6">
      <div class="hidden lg:grid lg:grid-cols-2 gap-6">
        <StoreRetributionsPodium
          v-if="retributionsAnalytics.ranking && retributionsAnalytics.ranking.length > 0"
          :ranking="retributionsAnalytics.ranking"
        />
        <div v-if="isTotalSellerAmountZero" class="bg-purple-50 rounded-lg p-8 text-center">
          <div class="mx-auto w-16 h-16 bg-white rounded-full flex items-center justify-center mb-4">
            <LightningBoltIcon class="w-8 h-8 text-yellow-200" />
          </div>
          <h3 class="text-xl font-semibold text-gray-900 mb-2">Débloquez vos premières primes !</h3>
          <p class="text-gray-600 mb-4">
            Réalisez votre première vente pour voir vos gains s’animer. Chaque vente compte — à vous de jouer !
          </p>
        </div>
        <OrganizationRetributionsPodium
          v-if="retributionsAnalytics.organizationRanking && retributionsAnalytics.organizationRanking.length > 0"
          :organizationRanking="retributionsAnalytics.organizationRanking"
        />
      </div>

      <RetributionsRankings
        :ranking="retributionsAnalytics.ranking"
        :organizationRanking="retributionsAnalytics.organizationRanking"
        :showOrganizationRetributionDetails="showOrganizationRetributionDetails"
        @viewDetails="$emit('viewDetails', $event)"
      />
    </div>
  </div>
</template>

<script>
import ManagementRetributionView from "@/components/retribution/ManagementRetributionView.vue";
import StoreRetributionsPodium from "@/components/retribution/podiums/StoreRetributionsPodium.vue";
import RetributionsRankings from "@/components/retribution/RetributionsRankings.vue";
import OrganizationRetributionsPodium from "@/components/retribution/podiums/OrganizationRetributionsPodium.vue";
import { CheckCircleIcon, LightningBoltIcon } from "@heroicons/vue/outline";

export default {
  name: "RetributionsAnalytics",

  components: {
    ManagementRetributionView,
    StoreRetributionsPodium,
    OrganizationRetributionsPodium,
    RetributionsRankings,
    CheckCircleIcon,
    LightningBoltIcon,
  },

  props: {
    retributionsAnalytics: {
      type: Object,
      default: null,
    },
    showManagementRetributionView: {
      type: Boolean,
      default: false,
    },
    showOrganizationRetributionDetails: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    isTotalSellerAmountZero() {
      if (!this.retributionsAnalytics || !this.retributionsAnalytics.totalSellerAmount) {
        return true;
      }
      return parseFloat(this.retributionsAnalytics.totalSellerAmount) === 0;
    },
  },
};
</script>
